import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export interface CompetencyProps extends PropsWithChildren {
  title?: string;
  description?: string;
  rating?: number | undefined;
  className?: string;
}

export const Competency = ({
  title,
  description,
  rating,
  children,
  className
}: CompetencyProps) => {
  const competencyClass = classNames('competency', className, {
    'competency--rated': rating != undefined
  });
  return (
    <div className={'competency__wrapper'}>
      <div className={competencyClass}>
        <div className={'competency__title'}>{title}</div>
        <div className={'competency__description'}>{description}</div>
        {rating != undefined && (
          <div className={'competency__rating'}>{rating}</div>
        )}
      </div>
      {children && <div className={'competency__children'}>{children}</div>}
    </div>
  );
};
